import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class CustomFieldsActions extends Actions{
    static get target(){
        return 'customFields'
    }
}


// WEBPACK FOOTER //
// ./actions/CustomFieldActions.js